import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import Settings from '@/include/settings';
import Cart from '@/models/Cart';
import Agent from '@/models/Agent';
import { loadLanguageAsync }  from './i18n';
import BodyClasses from '@/include/bodyClasses';
import LoadScript from 'vue-plugin-load-script'
import VueGtag from "vue-gtag";
import VueFacebookPixel from 'vue-analytics-facebook-pixel'
import VTooltip from 'v-tooltip'

Vue.use(LoadScript);
Vue.use(VTooltip)

require('@/plugins/formatter');
require('@/plugins/cart');


Vue.config.productionTip = false;
var reload = location.hash.replace('#/','').split('/')[1];

// first we check to see if we have a portal, if not, reroute to a the default portal
if (location.hash === '#/') {
  router.replace({ name: 'home', params: { portal: 'default' }});
}

// next we need to pull out the portal from the hash because the VueRouter isn't initialized yet
// and won't provide us with an interface to get the portal param.
let portal = location.hash.replace('#/','').split('/')[0];

// now the very first thing we do is load up the settings from the API using the protal we just set.
Settings.fetch(portal).then(ps => {

  const ga_obj = ps.portalAddOns.find((addOn) => addOn.typeId === 2);
  const pixel_obj = ps.portalAddOns.find((addOn) => addOn.typeId === 15);

  if (ga_obj && ga_obj.attributes && ga_obj.attributes){
    Vue.use(VueGtag, {
      config: { id: ga_obj.attributes.attributeValue }
    });
  } else {
    console.error("Google Analytics account not connected.");
  }

  if (pixel_obj && pixel_obj.attributes){
    var id = pixel_obj.attributes.find((attr) => attr.attributeName == "facebookId");
    if (id){
      Vue.use(VueFacebookPixel)
      Vue.analytics.fbq.init(id, {})
    } else {
      console.error("Facebook Pixel ID not found.");
    }
  } else {
    console.error("Facebook Pixel tracking not connected.");
  }
  // TODO Jamie grab settings from local storage or cookies. Things like active Language choice, active Currency choice.

  if (portal !== ps.slug) {
    // if the portal we requested came back with some other portal (likely default),
    // then replace the route to reflect this change.
    portal = ps.slug;
    router.replace({ path: location.hash.replace('#','').replace(portal, ps.slug) });
  }

  const landingPage = ps.landingPage;
  if (landingPage && !reload){
    switch(landingPage.type) {
      case "activity":
        if (landingPage.id != 0){
          router.replace({ name: 'activity', params: {portal: portal, id : landingPage.id}});
        } else if (landingPage.categoryId != 0){
          router.replace({ name : 'activity-items', params: {portal: portal, category : landingPage.categoryId}});
        } else {
          router.replace({name: 'category-activity', params: { portal: portal }});
        }
        break;
      case "package":
        if (landingPage.id != 0){
          router.replace({ name: 'package', params: {portal: portal, id : landingPage.id}});
        } else if (landingPage.categoryId != 0){
          router.replace({ name : 'package-items', params: {portal: portal, category : landingPage.categoryId}});
        } else {
          router.replace({name: 'category-package', params: { portal: portal }});
        }
        break;
      case "p2p":
        router.replace({name: 'p2p', params: { portal: portal }});
        break;
      case "product":
        if (landingPage.id != 0){
          router.replace({ name: 'product', params: {portal: portal, id : landingPage.id}});
        } else if (landingPage.categoryId != 0){
          router.replace({ name : 'product-items', params: {portal: portal, category : landingPage.categoryId}});
        } else {
          router.replace({name: 'category-product', params: { portal: portal }});
        }
        break;
      case "giftCert":
        router.replace({name: 'giftcert', params: { portal: portal }});
        break;
      default:
        // code block
    }
  }

  Settings.applyTheme(ps);
  Cart.load();

  // load the agent
  Agent.load().then(() => {

    // Settings provide us with the default lang. We need to load this up dynamically too.
    // Note that we've statically loaded en-US as our default lang. If the portal is also
    // en-US by default, the promise resolves immediately and nothing is fetched (so don't worry about that).
    loadLanguageAsync(ps.lang.default).then(() => {
      // now we can finally create and mount our app.
      const vue = new Vue({
        router,
        store,
        i18n,
        render: h => h(App)
      });

      // // settings might specify a default page to land on. Route to that now.
      // console.log('main router name', router.name);
      // if (router.history.current.name === 'home') {
      //   router.replace({ name: 'category-activities', params: { portal: portal }});
      // }

      vue.$mount('#app');
    });
  });
});
